export class Partner{

    constructor(name = '',rut,correo='',giro='',direccion='', comuna='', servicio='', fecha='' ){
        this.name = name;
        this.rut = rut;
        this.correo = correo;
        this.giro = giro;
        this.direccion = direccion;
        this.comuna = comuna;
        this.servicio = servicio;
        this.fecha = fecha;
    }

}